import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadNotificationSetting(action) {
  const {
    data: { accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/user-notification-setting`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadNotificationSetting.success(res.data.data.settings))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadNotificationSetting.failure())
  }
}

function* saveNotificationSetting(action) {
  const {
    data: { accessToken, settings },
    cb,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/user-notification-setting`,
      { settings },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.saveNotificationSetting.success(res.data.data.settings))

    // Cache in localStorage for NotificationProvider to read
    try {
      localStorage.setItem(
        'notification-settings',
        JSON.stringify(res.data.data.settings),
      )
      window.dispatchEvent(new CustomEvent('notification-settings-changed'))
    } catch (_e) {
      // ignore
    }

    if (cb) cb()
  } catch (err) {
    console.log(err.message)
    yield put(actions.saveNotificationSetting.failure())
  }
}

export default function* watchNotificationSetting() {
  yield all([
    takeEvery(
      actions.LOAD_NOTIFICATION_SETTING.REQUEST,
      loadNotificationSetting,
    ),
    takeEvery(
      actions.SAVE_NOTIFICATION_SETTING.REQUEST,
      saveNotificationSetting,
    ),
  ])
}
